export const H5_URL = 'https://www3.hkatv.vip';
